import {
  useCampaignFilter,
  useCurrentWorkspace,
  useSetCampaignFilter,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { EntitySearchInput } from './entitySearchInput';

export const CampaignSearchInput = ({
  onBlur,
  autoFocus,
}: { onBlur?: () => void; autoFocus?: boolean } = {}) => {
  const { t } = useTranslation();
  const { data: filter } = useCampaignFilter();
  const { mutateAsync } = useSetCampaignFilter();
  const currentWorkspace = useCurrentWorkspace(true);

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.workspaceId = currentWorkspace?.id;
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('campaigns.filter.searchPlaceholder', 'Search campaigns')}
      onBlur={onBlur}
      autoFocus={autoFocus}
    />
  );
};
